var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"text-nowrap paid",class:{ paid: _vm.value['orders_paid'], unpaid: !_vm.value['orders_paid'] }},[_vm._v(" "+_vm._s(_vm.formatPrice(_vm.value['price']))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }